export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";